import styled, { css } from "styled-components"

export const Overlay = styled.div`
    .comment-box {

        align-items: center;
        background-color: #f0f0f0;
        border: 1px solid #ccc;
        padding: 5px;
        margin-top: 10px;
        width: 300px;
        height:auto;
    }

    .comment-icon {
        margin-right: 10px;
        border-bottom: 1px solid #ccc;
        margin-bottom: 10px;
    }

    .comment-text {
        width:100%
    }
    .comment-button{
        text-align: center;
        width:100%;
        margin-top: 10px;
        border-top: 1px solid #ccc;
        padding-top: 10px;
    }
`;